import { zodResolver } from '@hookform/resolvers/zod'
import { Question, TenantMemberDisplayData } from '@kudos/http-client'
import { TFunction } from '@shared/types/types'
import { useT } from '@transifex/react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

export const MAX_NOM_RESPONSE_CHARS = 5000

const createNominateFormSchema = (t: TFunction) =>
  z.object({
    nominee: z
      .array(z.custom<TenantMemberDisplayData>())
      .nonempty({ message: t('Nominee is required') }),
    responses: z.array(
      z.object({
        questionId: z.string(),
        valueString: z
          .string()
          .trim()
          .min(1, { message: t('Response is required') })
          .max(MAX_NOM_RESPONSE_CHARS, {
            message: t('Response should not be more than {maxResponseLength} characters', {
              maxResponseLength: MAX_NOM_RESPONSE_CHARS,
            }),
          }),
        refinementId: z.string().optional(),
      }),
    ),
  })

export type NominateFormData = z.infer<ReturnType<typeof createNominateFormSchema>>

const useNominateForm = (questions?: Question[]) => {
  const t = useT()
  const NominateFormSchema = createNominateFormSchema(t)
  const defaultValues: NominateFormData = {
    // @ts-expect-error nominee should be empty by default
    nominee: [],
    responses:
      questions?.map(q => ({ questionId: q.id, valueString: '', refinementId: undefined })) ?? [],
  }

  const methods = useForm<NominateFormData>({
    resolver: zodResolver(NominateFormSchema),
    defaultValues,
  })

  return { methods }
}

export default useNominateForm
